import { Col } from 'antd'
import styled from 'styled-components'

const StyledUnknownWordsSortByCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
`

export default StyledUnknownWordsSortByCol
